import fonts from './fonts';
import { ProviderTypes } from './types';
export const fontFamilyToWixEmailsFontsHref = fonts
    .filter(({ provider }) => provider === ProviderTypes.google)
    .reduce((acc, { fontFamily, cdnName, normalizedFontFamily }) => ({
    ...acc,
    [normalizedFontFamily]: {
        href: `https://static.parastorage.com/unpkg/@wix/wix-emails-fonts@1.1.2/f/${encodeURIComponent(cdnName)}.css`,
        name: fontFamily,
    },
}), {});
//# sourceMappingURL=font-family-to-google-href.js.map